import React, { useState, useEffect, useRef, useCallback } from "react";
import { useMediaQuery } from "@material-ui/core";
import style from "./block.module.scss";
import Facebook from "../assets/facebook.svg";
import Twitter from "../assets/twitter.svg";
import Instagram from "../assets/instagram.svg";
import { ReactComponent as Menu } from "./menu.svg";
import { ReactComponent as Close } from "./close.svg";
import { ReactComponent as Scan } from "./scan-vert.svg";
import { ReactComponent as Search } from "../assets/search.svg";
import { ReactComponent as Bouteille } from "../assets/bouteilleIcon.svg";
import QrReader from "react-qr-reader";
import Button from "../shared/button-icon";
import apiFetch from "@wordpress/api-fetch";
import { useTranslation } from "react-i18next";
import AdherentLoginForm from "../adherent-login-form/block";
import PswdRecoveryForm from "../adherent-pswd-recovery-form/block";
import AdherentSignupForm from "../adherent-signup-form/block";

const MenuCompte = ({ chateaux }) => {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [chateauxOpen, setChateauxOpen] = useState(false);
  const handleMenuClick = useCallback(() => {
    setMenuOpen(!menuOpen);
    setChateauxOpen(false);
  }, [menuOpen, setMenuOpen, setChateauxOpen]);
  return (
    <div className={style.accountMenu}>
      <div className={style.menuButton} onClick={handleMenuClick}>
        {t("Mon compte")}
      </div>
      <div className={menuOpen ? style.menuContent : style.menuClosed}>
        <div
          className={
            chateauxOpen ? style.menuOptionChateauOpen : style.menuOptionChateau
          }
          onClick={() => setChateauxOpen(!chateauxOpen)}
        >
          <span>{t("Châteaux")}</span>
        </div>
        <div className={style.menuOption}>
          <a href="/events">{t("Mes Événements")}</a>
        </div>
        <div className={style.menuOption}>
          <a href="/actus">{t("Mes Actualités")}</a>
        </div>
        <div className={style.menuOption}>
          <a href="/reconnaissance">{t("Ma Reconnaissance")}</a>
        </div>
        <div className={style.menuOption}>
          <a href="/classement">{t("Mon Classement")}</a>
        </div>
        <div className={style.menuOption}>
          <a href="/account">{t("Mon compte")}</a>
        </div>
        <div className={style.menuOption}>
          <a href="/wp-json/adherent/v1/logout">{t("Se déconnecter")}</a>
        </div>
      </div>
      <div
        className={chateauxOpen ? style.menuChateau : style.menuChateauClosed}
      >
        {chateaux &&
          chateaux.map((chateau) => (
            <div className={style.menuOption} key={chateau.ID}>
              <a href={"/admin-chateau?id=" + chateau.ID}>
                {chateau.post_title}
              </a>
            </div>
          ))}
      </div>
    </div>
  );
};
const MenuClassement2020 = ({ link }) => {
  const { t } = useTranslation();

  return (
    <div className={style.accountMenu}>
      <a href={link}>
        <div className={style.menuButtonLarge2020}>{t("Classement 2020")}</div>
      </a>
    </div>
  );
};

const MenuClassement2025 = () => {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const handleMenuClick = useCallback(() => {
    setMenuOpen(!menuOpen);
  }, [menuOpen, setMenuOpen]);
  return (
    <div className={style.accountMenu}>
      <div className={style.menuButtonLarge} onClick={handleMenuClick}>
        {t("Classement 2025")}
      </div>
      <div
        className={menuOpen ? style.menuContentLarge : style.menuClosedLarge}
        style={{ maxHeight: menuOpen ? "92px" : "0px" }}
      >
        <div className={style.menuOption}>
          <a href="/inscription-classement">{t("Classement 2025")}</a>
        </div>
        <div className={style.menuOption}>
          <a href="/faq">{t("FAQ")}</a>
        </div>
      </div>
    </div>
  );
};

function Check({ open }) {
  const { t } = useTranslation();
  const qrRef = useRef();
  return (
    <div
      className={
        open === "scan" ? style.checkContent : style.checkContentClosed
      }
    >
      <div className={style.contentScan}>
        <div className={style.leftScan}>
          <Scan />
          <div>
            <h3 className={style.title}>{t("Vérifiez votre bouteille")}</h3>
            <div className={style.text}>
              {t(
                "Saisissez le code alphanumérique présent sur le Sticker Cru Bourgeois."
              )}
            </div>
          </div>
        </div>
        <div className={style.rightScan}>
          <form method="get" action={"/verification-chateau/"}>
            <input type="text" name="tokenVector" placeholder="XXX-XXX-XXX" />
            <span className={style.submit}>
              <input type="submit" value={t("Vérifier")} />
            </span>
          </form>
        </div>
        <div className={style.bottom}>
          <div className={style.separator}>
            <div className={style.bar} />
            <Bouteille />
            <div className={style.bar} />
          </div>
          <div class={style.qrCodeTitle}>
            {t("Scannez le QR Code présent sur le Sticker Cru Bourgeois.")}
          </div>
          <div onClick={() => qrRef.current.openImageDialog()}>
            <Button classIcon={style.icon} Icon={Scan} className={style.button}>
              {t("Scannez le QR Code")}
            </Button>
          </div>
          <div class={style.qrCodeTitle}>
            {t("Ou scannez avec votre application Appareil Photo habituelle")}
          </div>
          <QrReader
            onScan={(e) => window.location.replace(e)}
            legacyMode
            ref={qrRef}
          />
        </div>
      </div>
    </div>
  );
}

function SearchForm({ open, langId }) {
  const { t } = useTranslation();
  return (
    <div
      className={
        open === "search" ? style.searchContent : style.searchContentClosed
      }
    >
      <div className={style.contentSearch}>
        <form className={style.searchForm} method="get" action={"/search"}>
          <input type="hidden" name="lang" value={langId} />
          <input
            className={style.input}
            type="text"
            name="q"
            placeholder={t("Recherche")}
          />
          <span className={style.submit}>
            <input type="submit" value="" />
          </span>
        </form>
      </div>
    </div>
  );
}

function Block({
  custom_settings,
  menuTop,
  menuLang,
  logged,
  adherent,
  langId,
}) {
  const [open, setOpen] = useState(false);
  const [userChateaux, setUserChateaux] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [subMenuId, setSubMenuId] = useState(null);
  const [openModalLoggin, setOpenModalLoggin] = useState(false);
  const [openModalRecovery, setOpenModalRecovery] = useState(false);
  const [openModalSignup, setOpenModalSignup] = useState(false);
  const isMobile = useMediaQuery(`(max-width : ${style.mobileBreakpoint})`);
  const { t } = useTranslation();
  useEffect(() => {
    if (open) {
      document.body.style.overflowY = "hidden";
      return () => {
        document.body.style.overflowY = null;
      };
    }
  }, [open]);

  const toggleSubMenu = (menuId, e) => {
    // prevent the event from being propagated to the wrapper's onclick listener
    e.stopPropagation();

    if (subMenuId === menuId) {
      setSubMenuId(null);
    } else {
      setSubMenuId(null);
      if (subMenuId) {
        //if menu already open, wait until previous menu is closed
        setTimeout(() => setSubMenuId(menuId), 500);
      } else {
        setSubMenuId(menuId);
      }
    }
  };

  const menuTopValues = Object.values(menuTop);
  useEffect(() => {
    if (logged) {
      setIsLoggedIn(true);
      apiFetch({
        path: "/adherent/v1/castles",
        method: "GET",
      })
        .then((data) => {
          setUserChateaux(data);
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      setIsLoggedIn(false);
    }
  }, [setUserChateaux, setIsLoggedIn, logged]);

  useEffect(() => {
    if (openModalRecovery || openModalSignup) {
      setOpenModalLoggin(false);
    }
  }, [openModalRecovery, openModalSignup]);

  return (
    <div className={style.block}>
      <Check open={open} />
      <SearchForm open={open} langId={langId} />
      {openModalLoggin && (
        <AdherentLoginForm
          open={openModalLoggin}
          setVisibility={setOpenModalLoggin}
          openRecovery={setOpenModalRecovery}
          openSignup={setOpenModalSignup}
        />
      )}
      {openModalRecovery && (
        <PswdRecoveryForm
          open={openModalRecovery}
          setVisibility={setOpenModalRecovery}
        />
      )}
      {openModalSignup && (
        <AdherentSignupForm
          open={openModalSignup}
          setVisibility={setOpenModalSignup}
        />
      )}

      <div className={style.content}>
        <div
          className={style.left}
          onClick={() => {
            if (open === "menu") {
              setOpen(false);
              setSubMenuId(null);
            } else {
              setOpen("menu");
            }
          }}
        >
          {open !== "menu" ? <Menu /> : <Close />}
          <div className={open === "menu" ? style.menu : style.menuClosed}>
            <ul>
              <a href="/">
                <div className={style.logo} />
              </a>
              {menuTopValues.length &&
                menuTopValues.map((menuItem) =>
                  Object.values(menuItem.children).length ? (
                    <li className={style.childLink}>
                      <a
                        href={menuItem.url}
                        onClick={(e) => toggleSubMenu(menuItem.ID, e)}
                      >
                        {menuItem.title}
                      </a>
                      <ul
                        className={
                          menuItem.ID === subMenuId
                            ? style.childrenOpen
                            : style.children
                        }
                      >
                        {Object.values(menuItem.children).map((childItem) => (
                          <li>
                            <a href={childItem.url}>{childItem.title}</a>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ) : (
                    <li>
                      <a href={menuItem.url}>{menuItem.title}</a>
                    </li>
                  )
                )}
            </ul>
          </div>
        </div>
        <div className={style.right}>
          {<MenuClassement2020 link={custom_settings?.rank_2020_url} />}
          {<MenuClassement2025 />}
          {isLoggedIn ? (
            <MenuCompte chateaux={userChateaux} />
          ) : (
            <button
              className={style.loginButton}
              onClick={() => setOpenModalLoggin(true)}
            >
              {t("Espace adhérents")}
            </button>
          )}
          {custom_settings["map_url"] && (
            <a className={style.map} href={custom_settings["map_url"]}>
              {t("La carte des châteaux")}
            </a>
          )}
          <div
            className={style.scan}
            onClick={() => {
              if (open === "scan") {
                setOpen(false);
              } else {
                setOpen("scan");
              }
            }}
          >
            <Scan />
          </div>
          <div
            className={style.search}
            onClick={() => {
              if (open === "search") {
                setOpen(false);
              } else {
                setOpen("search");
              }
            }}
          >
            <Search />
          </div>
          {!isMobile && (
            <div className={style.socialBlock}>
              <a
                href={custom_settings["facebook"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={Facebook} alt="Open Facebook page" />
              </a>
              <a
                href={custom_settings["twitter"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={Twitter} alt="Open Twitter page" />
              </a>
              <a
                href={custom_settings["instagram"]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={Instagram} alt="Open Instagram Page" />
              </a>
            </div>
          )}
          <div
            className={style.menu}
            dangerouslySetInnerHTML={{ __html: menuLang }}
          />
        </div>
      </div>
    </div>
  );
}

export default Block;
